import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { trackPageView } from '../utils/analytics'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/over-ons',
    name: 'over-ons',
    component: () => import('../views/TeamView.vue')
  },
  {
    path: '/team',
    redirect: '/over-ons'
  },
  {
    path: '/privacybeleid',
    redirect: '/privacy'
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/fusies-en-overnames',
    name: 'fusies-en-overnames',
    component: () => import('../views/BedrijfOverlatenOfOvernemenView.vue')
  },
  {
    path: '/bedrijf-overlaten-of-overnemen',
    redirect: '/fusies-en-overnames'
  },
  {
    path: '/verkoopmandaten',
    name: 'verkoopmandaten',
    component: () => import('../views/VerkoopmandatenView.vue')
  },
  {
    path: '/aankoopmandaten',
    name: 'aankoopmandaten',
    component: () => import('../views/AankoopmandatenView.vue')
  },
  {
    path: '/overnamebegeleiding',
    name: 'overnamebegeleiding',
    component: () => import('../views/OvernamebegeleidingView.vue')
  },
  {
    path: '/cfo-as-a-service',
    name: 'cfo-as-a-service',
    component: () => import('../views/CfoAsAServiceView.vue')
  },
  {
    path: '/financieel-advies',
    name: 'financieel-advies',
    component: () => import('../views/FinancieelAdviesView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import('../views/DisclaimerView.vue')
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/CookiesView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Track page views for analytics (only if consent given)
router.afterEach((to) => {
  trackPageView(to.fullPath)
})

export default router
